import { v4 } from "uuid";

export enum FileType {
  img = "imag",
  file = "file",
}

export const FileHelper = {
  getBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  },
  createFileName(fileName: string) {
    return `${v4()}~~~~${fileName}`;
  },
  extractFileName(fileName: string) {
    if (fileName.includes("~~~~")) return fileName.split("~~~~")[1];

    return fileName;
  },
};
